import React from 'react';

import { CharacterItem } from './character-item';
import { AssetGrid } from '../../../components/grid';

import type { Character } from '../../../app/entities/character';

import styles from './character-cards.module.scss';
type CharacterCardsProps = {
  characters: Character[];
};

export const CharacterCards: React.FC<CharacterCardsProps> = ({ characters }) => (
  <AssetGrid className={styles['container']}>
    {characters?.map((character) => (
      <CharacterItem key={character._id} character={character} />
    ))}
  </AssetGrid>
);
